import { render, staticRenderFns } from "./statistique-diagnostiques.html?vue&type=template&id=60bf7dbc&scoped=true&external"
import script from "./statistique-diagnostiques.js?vue&type=script&lang=js&external"
export * from "./statistique-diagnostiques.js?vue&type=script&lang=js&external"
import style0 from "./statistique-diagnostiques.scss?vue&type=style&index=0&id=60bf7dbc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf7dbc",
  null
  
)

export default component.exports